import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import TextArea from '@mos-cat/text-area';

import Button from '../../../Button/Button';

import './Form.pcss';

const Form = ({
  className,
  visible,
  error,
  onChange,
  onCancel,
  onSubmit,
  commentary
}) => {
  if (visible) {
    return (
      <div className={cn('FeedbackForm', className)}>
        <TextArea
          label="Комментарий или предложение"
          value={commentary}
          error={error}
          name="FeedbackForm__commentary"
          maxLength={1000}
          onChange={onChange}
          className="FeedbackForm__commentary"
        />
        <Button
          className="FeedbackForm__submit-form-button"
          primary
          size="small"
          onClick={onSubmit}
        >
          Отправить
        </Button>
        <button
          className="mos-link FeedbackForm__cancel-form-button"
          type="button"
          onClick={onCancel}
        >
          Отменить
        </button>
      </div>
    );
  }

  return null;
};

Form.propTypes = {
  className: PropTypes.string,
  commentary: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

Form.defaultProps = {
  className: ''
};

export default Form;
